module.exports = __webpack_public_path__ + "img/money-sign-orange.145561d9.svg";